<template>
  <div class="wrapper">
    <div class="full-area padded vertically-centered desktop-wrapper">
      <SensataSplash></SensataSplash>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',

  transition: 'page',

  components: {
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  data () {
    return {
      canForward: false
    }
  },

  computed: {
    sensataShowSplash () {
      return process.env.VUE_APP_SHOW_SENSATA_SPLASH
    }
  },

  methods: {
    pushSite () {
      if (!this.canForward) {
        return
      }
      this.$router.push('/scan')
    }
  },

  mounted () {
    var sensataSplashTimer = this.sensataShowSplash ? 2200 : 0

    setTimeout(() => {
      this.canForward = true
      this.pushSite()
    }, sensataSplashTimer)
  }
}
</script>

<style scoped lang="scss">
h1 {
  color: $color-emphasis;
}

.wrapper {
  background: white !important;
}
.desktop-wrapper {
  box-shadow: none;
}
</style>
